// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"264":"61da5a27","312":"9a9b7725","472":"3984a200","685":"58c6b362","867":"b8c53be3","935":"9312ec77"}[chunkId] + ".chunk.css";
};